<!-- 游学列表 -->

<template>
  <div class="main">
    <!-- 顶部搜索 -->
    <div class="s_wrapper">
      <el-input class="s_input" placeholder="搜索游学名称" suffix-icon="el-icon-search" v-model="name" :clearable="true"
        @change="onSearch"></el-input>
      <el-cascader :options="cascaderOptions" placeholder="选择分类" v-model="categoryIds" @change="onSearch"
        :props="cascaderprops" collapse-tags clearable></el-cascader>
      <el-select v-model="shelfStatus" placeholder="选择状态" @change="onSearch" clearable>
        <el-option v-for="item in shelfOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-button class="btn" type="primary" @click="handleApply(1)">新增游学</el-button>
    </div>
    <div class="globle_border" v-loading="loading">
      <!-- 表格 -->
      <div class="g_table">
        <el-table :data="tableData" style="width: 100%" max-height="540">
          <el-table-column label="序号" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column min-width="210" show-overflow-tooltip prop="name" label="游学名称"></el-table-column>
          <el-table-column min-width="210" show-overflow-tooltip prop="categoryName" label="游学分类"></el-table-column>
          <el-table-column min-width="210" show-overflow-tooltip label="游学时间">
            <template slot-scope="scope">
              <span v-if="scope.row.startTime"> {{ `${scope.row.startTime} -- ${scope.row.endTime}` }}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="190" show-overflow-tooltip prop="teacherName" label="带队老师"></el-table-column>
          <el-table-column min-width="190" show-overflow-tooltip prop="signUpCount" label="报名数量"></el-table-column>
          <el-table-column min-width="160" show-overflow-tooltip label="课程标签">
            <template slot-scope="scope">
              <span v-if="scope.row.label == 1">最新</span>
              <span v-if="scope.row.label == 2">热门</span>
              <span v-if="scope.row.label == 3">推荐</span>
            </template>
          </el-table-column>
          <el-table-column min-width="130" show-overflow-tooltip prop="price" label="售价(元)"></el-table-column>
          <el-table-column label="状态" header-align="center" align="center" min-width="100">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status" inactive-color="#E2E2E2"
                @change="changeOnlineStatus(scope.row)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column min-width="140" show-overflow-tooltip prop="sort" label="排序"></el-table-column>
          <el-table-column label="操作" header-align="center" align="center" width="300" min-width="300" fixed="right">
            <template slot-scope="scope">
              <el-button size="small" class="btn" type="primary" plain @click="handleBuy(scope.row)">已购用户</el-button>
              <el-button size="small" class="btn" type="primary" plain @click="handleApply(scope.row)">编辑</el-button>
              <el-button size="small" class="btn" type="danger" plain @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
        layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      shelfStatus: "", // 选择上下架状态
      shelfOptions: [{
        value: "1",
        label: "上架",
      },
      {
        value: "0",
        label: "下架",
      },
      ],
      name: "",
      categoryIds: "",
      cascaderOptions: [],
      cascaderprops: {
        checkStrictly: false,
        emitPath: false,
        multiple: true,
        value: "id",
        label: "categoryName",
        children: "children",
      },
      // 表格数据
      tableData: [],
      // 分页
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.selectStudyTourInfo()
    this.getCategoryList()
  },
  methods: {
    // 获取列表
    selectStudyTourInfo() {
      this.loading = true
      this.$axios
        .post(this.$api.selectStudyTourInfo, {
          categoryId: this.categoryIds.length == 0 ? null : this.categoryIds,
          name: this.name || null,
          status: this.shelfStatus,
          page: this.currentPage,
          pageSize: this.pageSize,
        })
        .then(res => {
          if (res.code == 100) {
            if (res.result) {
              this.tableData =
                res.result.list.map(e => {
                  return {
                    ...e,
                    status: e.status == 1 ? true : false,
                  }
                }) || []
              this.totalItemsCount = res.result.totalCount
            }
            this.loading = false
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    // 分类选择
    getCategoryList() {
      this.$axios
        .get(this.$api.getStudyTourCategoryList)
        .then(res => {
          if (res.code == 100) {
            this.cascaderOptions = res.result
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    // 上下架状态
    changeOnlineStatus(row) {
      const originalSwitch = row.status
      this.$confirm(`确定${row.status ? "上架" : "下架"}吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post(this.$api.updateStatusTourInfo, {
              id: row.id,
              status: row.status ? 1 : 0,
            })
            .then(res => {
              this.$set(row, "status", originalSwitch)
              this.$message.success(res.desc)
              this.selectStudyTourInfo()
            })
            .catch(err => {
              this.$set(row, "status", !originalSwitch)
              this.$message.error(err.desc)
              this.selectStudyTourInfo()
            })
        })
        .catch(() => {
          this.$set(row, "status", !originalSwitch)
          this.selectStudyTourInfo()
        })
    },
    // 新增 / 修改
    handleApply(row) {
      if (row == 1) {
        this.$router.push("/studyTour/detail/applyStudyTour")
      } else {
        this.$router.push({ path: "/studyTour/detail/applyStudyTour", query: { id: row.id } })
      }
    },

    // 删除
    handleDelete(row) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post(`${this.$api.deleteTourInfo}/${row.id}`,)
            .then(res => {
              if (res.code == 100) {
                this.$message.success(res.desc)
                this.selectStudyTourInfo()
              }
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        })
        .catch(() => {
          this.$message("取消删除")
        })
    },
    handleBuy(row) {
      this.$router.push({
        path: "/studyTour/detail/buyerList",
        query: {
          id: row.id,
          type: 1,
        },
      })
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },
    // 搜索
    onSearch() {
      this.clearData()
      this.selectStudyTourInfo()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.pageSize = e
      this.onSearch()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.selectStudyTourInfo()
    },
  },
}
</script>

<style lang="scss" scoped>
.main {}
</style>
